const map: Record<string, string> = {
  cc_rejected_insufficient_amount: "Saldo/limite insuficiente no cartão.",
  cc_rejected_bad_filled_card_number: "Número do cartão incorreto. Confira.",
  cc_rejected_bad_filled_date: "Data de validade inválida.",
  cc_rejected_bad_filled_security_code: "Código de segurança inválido.",
  cc_rejected_bad_filled_other: "Dados do cartão incorretos.",
  cc_rejected_call_for_authorize:
    "Autorização necessária pelo banco — ligue para o emissor do cartão.",
  cc_rejected_high_risk:
    "Pagamento recusado por risco. Tente outro cartão ou PIX.",
  cc_rejected_card_disabled: "Cartão desabilitado. Contate o emissor.",
  cc_rejected_duplicated_payment:
    "Pagamento duplicado detectado. Aguarde alguns minutos.",
  cc_rejected_max_attempts:
    "Limite de tentativas atingido. Tente outro cartão.",
  cc_rejected_other_reason: "Pagamento não autorizado pelo emissor.",
  cc_rejected_invalid_installments:
    "Este cartão não aceita esse número de parcelas. Escolha outra opção de parcelamento.",
  cc_rejected_card_type_not_allowed:
    "A função crédito não está habilitada neste cartão. Tente outro cartão ou PIX.",
  cc_rejected_card_error:
    "Não conseguimos processar seu pagamento. Tente novamente ou use outro cartão.",
  cc_rejected_blacklist:
    "Não foi possível processar seu pagamento. Tente outro cartão ou PIX.",
  cc_rejected_3ds_mandatory:
    "É necessária a autenticação do cartão (3DS). Tente outro cartão ou PIX.",
  cc_amount_rate_limit_exceeded:
    "O valor excede o limite permitido para este cartão. Tente outro cartão ou PIX.",
  rejected_insufficient_data:
    "Faltaram dados para processar o pagamento. Confira as informações e tente novamente.",
  rejected_by_bank: "Operação recusada pelo banco. Contate o emissor do cartão.",
  rejected_by_regulations:
    "Pagamento recusado por regulamentações. Tente outro cartão ou PIX.",
  insufficient_amount: "Saldo/limite insuficiente no cartão.",
  cc_rejected_time_out:
    "A operadora demorou a responder. Tente novamente ou use outro cartão.",
  rejected_high_risk:
    "Pagamento recusado por risco. Tente outro cartão ou PIX.",
  rejected_by_biz_rule:
    "Pagamento recusado por regras da operadora. Tente outro cartão ou PIX.",
}

export function mapCardStatusDetail(code?: string): string {
  if (!code) return "Pagamento recusado. Tente outro cartão ou pague com PIX."
  return (
    map[code] ??
    "Pagamento recusado pelo emissor. Tente outro cartão ou pague com PIX."
  )
}
